import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-driver-trips-modal',
  templateUrl: './driver-trips-modal.component.html',
  styleUrls: ['./driver-trips-modal.component.css']
})
export class DriverTripsModalComponent implements OnInit {
@Input() driverObj
@Output() onClose = new EventEmitter()
@Input()trips;

  constructor() { }

  ngOnInit() {
  }

  closeModal() {
    this.onClose.emit();
  }
}
